import styled from "styled-components";
import fipayFonts from "../../../theme/index";
import { colors } from "../../../theme/color";

export const PaymentMethodContainer = styled.div`
  display: flex;
  width: 100%;
  height: 718px;
  padding: 46px 172px 77.667px 172px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 47px;
  box-sizing: border-box;
  /* border: 2px solid red; */
  background: var(--General-White, #fff);

  @media screen and (max-width: 768px) {
    width: 768px;
    height: 466px;
    display: flex;
    padding: 35px 62px 59.667px 62px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 60px;
  }
  @media screen and (max-width: 430px) {
    width: 100%;
    height: 514px;
    display: flex;
    padding: 50px 24px 30px 24px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 70px;
  }
  @media screen and (max-width: 375px) {
    width: 375px;
    height: 714px;
    display: flex;
    padding: 2px 20px 10px 20px;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    margin-top: 70px;
  }
  @media screen and (max-width: 320px) {
    width: 100%;
    height: 714px;
    display: flex;
    padding: 2px 20px 10px 20px;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    margin-top: 70px;
  }
`;

export const IconsHolder = styled.div`
  width: 1096px;
  height: 147.33px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 100px;

  @media screen and (max-width: 1024px) {
    width: 644px;
    height: 328.33px;
    display: flex;
    /* flex-direction: column; */
    justify-content: center;
    align-items: center;
    gap: 75px;
    flex-wrap: wrap;
  }
  @media screen and (max-width: 768px) {
    width: 644px;
    height: 328.33px;
    display: flex;
    /* flex-direction: column; */
    justify-content: center;
    align-items: center;
    gap: 75px;
    flex-wrap: wrap;
  }
  @media screen and (max-width: 430px) {
    width: 349px;
    height: 160px;
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    gap: 30px;
    flex-wrap: wrap;
  }
  @media screen and (max-width: 375px) {
    width: 269px;
    height: 160px;
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    gap: 38px;
    flex-wrap: wrap;
  }
`;

export const Paypal = styled.img`
  width: 85.18px;
  height: 100.62px;
  object-fit: cover;

  @media screen and (max-width: 1024px) {
    width: 52px;
    height: 52px;
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 40px;
    height: 47px;
  }
  @media screen and (max-width: 375px) {
    /* width: 44px;
    height: 50px; */
    width: 40px;
    height: 47px;
  }
`;

export const CashApp = styled.img`
  width: 98.22px;
  height: 98.22px;
  object-fit: cover;

  @media screen and (max-width: 1024px) {
    width: 45.33px;
    height: 45.33px;
  }

  @media screen and (max-width: 430px) {
    width: 40px;
    height: 40px;
  }
  @media screen and (max-width: 375px) {
    width: 40px;
    height: 40px;
  }
`;

export const Zelle = styled.img`
  width: 134.54px;
  height: 56.81px;
  object-fit: contain;

  @media screen and (max-width: 1024px) {
    width: 60.77px;
    height: 26.41px;
  }

  @media screen and (max-width: 430px) {
    width: 60.77px;
    height: 26.41px;
  }
  @media screen and (max-width: 375px) {
    width: 60.77px;
    height: 26.41px;
  }
`;

export const Bitcoin = styled.img`
  width: 110.99px;
  height: 111px;
  object-fit: cover;

  @media screen and (max-width: 1024px) {
    width: 64px;
    height: 64px;
  }
  @media screen and (max-width: 768px) {
    width: 64px;
    height: 64px;
  }

  @media screen and (max-width: 430px) {
    width: 40px;
    height: 40px;
  }
  @media screen and (max-width: 375px) {
    /* width: 64px;
    height: 64px; */
    width: 40px;
    height: 40px;
  }
`;

export const Venmo = styled.img`
  width: 81px;
  height: 72px;
  object-fit: cover;

  @media screen and (max-width: 1024px) {
    width: 56px;
    height: 52px;
  }
  @media screen and (max-width: 768px) {
    width: 56px;
    height: 52px;
  }

  @media screen and (max-width: 430px) {
    width: 44px;
    height: 40px;
  }
  @media screen and (max-width: 375px) {
    width: 44px;
    height: 40px;
  }
`;
